import React,{Component} from 'react';

import {Tabs,Tab,Typography,AppBar} from '@material-ui/core';



import Retenciones from './ListarRetenciones';
import Liquidaciones from './ListarLiquidaciones';
import DBHandler from '../DBHandler';


export default class Principal extends Component {
    constructor(props){
        super(props);
        this.state={
            liquidaciones:[],
            cuit:props.cuit,
            tab:0,
        }

        this.db = new DBHandler();
        this.pedirLiquidaciones.bind(this)();
    }

    componentWillReceiveProps(props){
        this.setState({
            cuit:props.cuit,
        })
    }


    cargarLiquidaciones(liq){
        this.setState({
            liquidaciones:liq
        })
    }

    pedirLiquidaciones(){
        this.db.enviarPeticion(
            this.cargarLiquidaciones.bind(this),
            "retenciones/listarLiquidaciones",
            'POST',
            {
                'usuario':this.state.cuit
            }
        )
    }

    render(){
        return(<div>
            {this.state.liquidaciones.length === 0 ? <div><Retenciones cuit={this.state.cuit}></Retenciones></div>:
            <div><AppBar>
                    <Tabs 
                        value={this.state.tab}
                        onChange={(ev,val)=>this.setState({tab:val})}
                    centered>
                        <Tab label='Retenciones' />
                        <Tab label='Liquidaciones' />
                    </Tabs>
                </AppBar>
                <div hidden={this.state.tab !== 0}>
                    <Retenciones cuit={this.state.cuit}></Retenciones>
                </div>
                <div hidden={this.state.tab !== 1}>
                    <Liquidaciones liquidaciones={this.state.liquidaciones}></Liquidaciones>
                </div>
                </div>}
        </div>)
    }
}